import api from './api';

export const channelService = {
  async getChannels() {
    const response = await api.get('/channels');
    return response.data;
  },

  async getChannel(id) {
    const response = await api.get(`/channels/${id}`);
    return response.data.data;
  },

  async createChannel(data) {
    const response = await api.post('/channels', data);
    return response.data.data;
  },

  async updateChannel(id, data) {
    const response = await api.put(`/channels/${id}`, data);
    return response.data.data;
  },

  async deleteChannel(id) {
    const response = await api.delete(`/channels/${id}`);
    return response.data.data;
  },
};
